// src/components/Sales/SalesFilter.tsx

import React, { useState, useEffect } from 'react';
import { formatDateTime } from '../../types/sales';
import { CircularProgress } from '@mui/material';

import {
    Paper,
    Grid,
    TextField,
    Box,
    Typography,
    MenuItem,
    Button
} from '@mui/material';

interface SalesFilterProps {
    currentMonth: string;
    onMonthChange: (salesMonth: string) => void;
    calculationDate?: string | null;  // オプショナルにしておく
    calculationDateLoading?: boolean;  // オプショナルにしておく
}

export const SalesFilter: React.FC<SalesFilterProps> = ({
    currentMonth,
    onMonthChange,
    calculationDate,
    calculationDateLoading
}) => {
    // 年と月の選択用の状態を管理
    const [year, setYear] = useState<string>("");
    const [month, setMonth] = useState<string>("");

    // 年と月の選択肢を生成
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 5 }, (_, i) => String(currentYear - 2 + i));
    const months = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'));

    // 現在の選択された月が変更された時に年と月の状態を更新
    useEffect(() => {
        if (currentMonth) {
            const [yearPart, monthPart] = currentMonth.split('-');
            setYear(yearPart);
            setMonth(monthPart);
        }
    }, [currentMonth]);

    // 検索ボタンがクリックされた時の処理
    const handleSearch = () => {
        if (year && month) {
            onMonthChange(`${year}-${month}`);
        }
    };

    return (
        <Paper sx={{ p: 2, mb: 3 }}>
            <Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6" component="h2">
                    売上データ検索
                </Typography>
                {/* 集計日表示を右端に配置 */}
                {calculationDate && (
                    <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center' }}>
                        最終集計日: {formatDateTime(calculationDate)}
                        {calculationDateLoading && (
                            <CircularProgress size={16} sx={{ ml: 1 }} />
                        )}
                    </Typography>
                )}
            </Box>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={4} md={3}>
                    <TextField
                        select
                        fullWidth
                        label="年"
                        value={year}
                        onChange={(e) => setYear(e.target.value)}
                        variant="outlined"
                    >
                        {years.map((y) => (
                            <MenuItem key={y} value={y}>
                                {y}年
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                    <TextField
                        select
                        fullWidth
                        label="月"
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                        variant="outlined"
                    >
                        {months.map((m) => (
                            <MenuItem key={m} value={m}>
                                {parseInt(m)}月
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        onClick={handleSearch}
                        fullWidth
                        sx={{ height: '56px' }}
                    >
                        検索
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
    
};